module.exports = __webpack_public_path__ + "img/pizzaset-758.d52e2b96.png";